import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';

export interface IFlippableCardProps {
  frontContent: JSX.Element;
  backContent: JSX.Element;
  isFlipped?: boolean;
  className?: string;
}

const blockName = 'flippable-card';

export default function FlippableCard({
  frontContent,
  backContent,
  isFlipped: propIsFlipped = null,
  className = null,
}: IFlippableCardProps) {
  const [stateIsFlipped, setFlipped] = React.useState<boolean>(false);

  const isFlipped = function (): boolean {
    if (propIsFlipped === null) {
      return stateIsFlipped;
    } else {
      return propIsFlipped;
    }
  };

  const flip = function (): void {
    if (propIsFlipped === null) {
      setFlipped(!stateIsFlipped);
    }
  };

  const bem = bemBlock(blockName);

  return (
    <div
      className={bem(
        null,
        [
          {
            flipped: isFlipped(),
          },
        ],
        [className]
      )}
      onClick={() => flip()}
    >
      <div className={bem('wrapper')}>
        <div className={bem('card-face', 'front')}>{frontContent}</div>
        <div className={bem('card-face', 'back')}>{backContent}</div>
      </div>
    </div>
  );
}
